// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISendFirstMessageToAgentRequest,
  TSendFirstMessageToAgentModel,
  IMappers,
  TSendFirstMessageToAgentResponse,
  ISendFirstMessageToAgentResponse,
  ISendFirstMessageToAgentResponseError,
} from './types';

export const defaultConfig: TSendFirstMessageToAgentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/send-first-message-to-agent/',
  requestType: 'json',
} as TSendFirstMessageToAgentModel;

export function createSendFirstMessageToAgentModel(
  parameters: ISendFirstMessageToAgentRequest,
): TSendFirstMessageToAgentModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendFirstMessageToAgentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISendFirstMessageToAgentRequest;
}

export async function fetchSendFirstMessageToAgent<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISendFirstMessageToAgentOptions<TResponse200, TResponse400>): Promise<
  TSendFirstMessageToAgentResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createSendFirstMessageToAgentModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendFirstMessageToAgentResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISendFirstMessageToAgentResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSendFirstMessageToAgentResponse;
}
